<template>
	<div class="stores">
    	<div>小乔动感单车用户卡路里燃脂榜</div>
	    <div class="searchBtn">
	      	<el-date-picker
	      		v-model="timeVal"
	      		type="daterange"
	      		range-separator=" —— "
	      		start-placeholder="Time From(O)"
	      		end-placeholder="Time To(O)"
      			value-format="yyyy-MM-dd">
	    	</el-date-picker>
	    	<div class="sortright">
		    	<div class="sort">排序</div>
		    	<el-select v-model="orderType" placeholder="请选择">
				    <el-option
				      	v-for="item in options"
				      	:key="item.value"
				      	:label="item.label"
				      	:value="item.value">
				    </el-option>
			  </el-select>
			  <el-button type="primary" @click="search_mine" class="sbtn">搜索</el-button>
		  	</div>
	    </div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData" highlight-current-row  style="width: 100%">
	        		<el-table-column prop="username" label="userName">
	        			<template slot-scope="scope">
	        				<router-link :to="{path:'/homekcalDetail', query: {id:scope.row.userId,nickname:scope.row.nickname}}">{{scope.row.username}}</router-link>
	        			</template>
	        		</el-table-column>
			        <el-table-column prop="nickname" label="NickName"></el-table-column>
			        <el-table-column prop="mobile" label="Phone"></el-table-column>
			        <el-table-column prop="codeName"  label="codeName"></el-table-column>
			        <el-table-column prop="vipExpireTime" label="ExpireTime"></el-table-column>
			        <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="CreateTime"></el-table-column>
					<el-table-column prop="kcal"  label="Calorie"></el-table-column>
			        <el-table-column prop="first" :formatter="this.global.dateFormat" label="First"></el-table-column>
			        <el-table-column prop="last" :formatter="this.global.dateFormat" label="Last"></el-table-column>
		        </el-table>
	      	</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" :page-sizes="[10, 30, 100, 500]" layout="total, sizes, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	      	<div style="clear:both"></div>
	    </div>
  	</div>
</template>

<script>
export default {
    data() {
      	return {
	        timeVal:'',
	        tableData:[],
	        pageNum: 1,
      		limit: 10,
      		totalPage: 10,
      		orderType:'',//排序
      		options:[
      			{
      				value:1,
      				label:'Calorie'
      			},
      			{
      				value:2,
      				label:'ExpireTime'
      			},
      			{
      				value:3,
      				label:'CreateTime'
      			},
      			{
      				value:4,
      				label:'FirstLast'
      			},
      			{
      				value:5,
      				label:'Last'
      			}
      		]
      	};
    },
    methods:{
    	init() {
	      	var params = {
	        	pageNum: this.pageNum,
	        	limit: this.limit,
	        	startStatisticsTime:this.timeVal?this.$moment(this.timeVal[0]).valueOf():'',
	        	endStatisticsTime:this.timeVal?this.$moment(this.timeVal[1]).valueOf():'',
	        	orderType:this.orderType
	      	};
	      	this.$get("/report/queryCycleCalorieRank", params)
	        .then(res => {
	          	if (res.code == 0) {
	            	this.tableData = res.data.list;
	            	this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	    },
    	search_mine(){
    		this.init(); 
    	},
    	//当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
	    handleSizeChange(val){
	    	this.limit=val;
	    	this.pageNum = 1;
	      	this.init();
	    },
    },
    mounted() {
    	this.init(); 
    },
}
</script>
<style scope>
.sbtn{
	margin-left: 10px
}
.searchBtn{
	display:flex;
	margin: 20px 0;
	align-items: center;
}
.sort{
	margin: 0 10px 0 20px;
	color: #666;
	font-size: 14px;
}
.sortright{
	display: flex;
	align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/views/report/homekcal.vue